import { Link } from 'react-router-dom'
import Ladehinweis from '../komponenten/Ladehinweis'
import { seit, useLaden, zeitpunktText } from '../lib/laden'
import { holeUebersicht, type Schlange } from '../lib/warteschlangen'

/**
 * Startseite (§8.6): die vier Zahlen, die älteste wartende Sache je Schlange
 * und die letzten zehn Entscheidungen. Mehr nicht — Analytics kommt später.
 */

const PFAD: Record<Schlange['name'], string> = {
  fotos: '/fotos',
  bewertungen: '/bewertungen',
  einreichungen: '/einreichungen',
  meldungen: '/meldungen',
  profilmeldungen: '/profilmeldungen',
}

const NAME: Record<Schlange['name'], string> = {
  fotos: 'Fotos',
  bewertungen: 'Bewertungstexte',
  einreichungen: 'Einreichungen',
  meldungen: 'Meldungen',
  profilmeldungen: 'Profilmeldungen',
}

const ENTSCHEIDUNG_TEXT: Record<string, string> = {
  accepted: 'angenommen',
  rejected: 'abgelehnt',
  reverted: 'zurückgenommen',
  auto_approved: 'automatisch freigegeben',
}

const ZIEL_TEXT: Record<string, string> = {
  media: 'Bild',
  review: 'Bewertung',
  submission: 'Einreichung',
  report: 'Meldung',
  place: 'Ort',
}

export default function Uebersicht() {
  const [zustand] = useLaden(holeUebersicht)

  if (zustand.art !== 'da') return <Ladehinweis zustand={zustand} />
  const { schlangen, letzte } = zustand.wert

  const gesamt = schlangen.reduce((s, q) => s + q.anzahl, 0)

  return (
    <section className="uebersicht">
      <div className="stapel-kopf">
        <h1>Übersicht</h1>
        <p className="gedaempft">
          {gesamt === 0
            ? 'Nichts offen.'
            : `${gesamt} ${gesamt === 1 ? 'Vorgang wartet' : 'Vorgänge warten'}.`}
        </p>
      </div>

      <div className="zahlen-raster">
        {schlangen.map((q) => (
          <Link key={q.name} to={PFAD[q.name]} className="karte zahl-karte">
            <p className="gedaempft">{NAME[q.name]}</p>
            <p className={q.anzahl > 0 ? 'zahl zahl-gross wartet' : 'zahl zahl-gross'}>
              {q.anzahl}
            </p>
            <p className="leise">{q.anzahl > 0 ? seit(q.aeltestes) : 'nichts offen'}</p>
          </Link>
        ))}
      </div>

      <div className="karte">
        <h2>Die letzten zehn Entscheidungen</h2>
        {letzte.length === 0 ? (
          <p className="gedaempft">Noch nichts entschieden.</p>
        ) : (
          <ul className="entscheidungen">
            {letzte.map((d) => (
              <li key={`${d.target_kind}:${d.target_id}:${d.decided_at}`}>
                <span className="leise entscheidung-datum">{zeitpunktText(d.decided_at)}</span>
                <span>
                  {ZIEL_TEXT[d.target_kind] ?? d.target_kind}{' '}
                  <strong
                    className={
                      d.decision === 'rejected' ? 'wort-ab' : 'wort-frei'
                    }
                  >
                    {ENTSCHEIDUNG_TEXT[d.decision] ?? d.decision}
                  </strong>
                  {d.betroffener && (
                    <span className="gedaempft">
                      {' '}
                      ·{' '}
                      {d.betroffener_name ?? `Anonym · ${d.betroffener.slice(0, 6)}`}
                    </span>
                  )}
                </span>
                {d.reason && <span className="leise entscheidung-grund">{d.reason}</span>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}
